import MiscHelper from './MiscHelper';

class DrupalHelper {
  static getSetting(name, default_value = '') {
    const root = this.getRootObj();

    if (root.map_settings !== 'undefined') {
      return root.map_settings[name] || default_value;
    }

    return default_value;
  }

  static getData() {
    const root = this.getRootObj();

    if (root.data) {
      let data = {};

      if (root.data.features && root.data.features.length > 0) {
        root.data.features.forEach((feature) => {
          const country = feature.properties.data.field_term_countries ? MiscHelper.plaintext(feature.properties.data.field_term_countries) : null;
          const fellowship = feature.properties.data.field_ip_fellow_fellowship ? MiscHelper.plaintext(feature.properties.data.field_ip_fellow_fellowship) : null;
          const title = feature.properties.data.title ? MiscHelper.plaintext(feature.properties.data.title) : null;
          const icon = feature.properties.icon ? feature.properties.icon : null;
          const coordinate = feature.geometry.coordinates || null;

          if (country && fellowship) {
            if (!data[country]) {
              data[country] = {};
            }

            if (!data[country][fellowship]) {
              data[country][fellowship] = {};
            }

            if (!data[country][fellowship]['coordinate'] && coordinate) {
              data[country][fellowship]['coordinate'] = coordinate;
            }

            if (!data[country][fellowship]['icon'] && icon) {
              data[country][fellowship]['icon'] = icon;
            }

            if (!data[country][fellowship]['entries']) {
              data[country][fellowship]['entries'] = [];
            }

            if (title) {
              data[country][fellowship]['entries'].push({
                title: title,
                disable_pubmed_link: MiscHelper.toBool(feature.properties.data.field_disable_link),
                custom_link: MiscHelper.plaintext(feature.properties.data.field_link_override ?? '')
              });
            }
          }
        });
      }

      return data;
    }

    return [];
  }

  static getCoordinateList() {
    const root = this.getRootObj();

    if (root.data) {
      let data = [];

      if (root.data.features && root.data.features.length > 0) {
        root.data.features.forEach((feature) => {
          data.push(feature.geometry.coordinates);
        })
      }

      return data;
    }

    return [];
  }

  static getLegend() {
    const root = this.getRootObj();

    if (root.legend) {
      return root.legend || [];
    }

    return [];
  }

  static getLegendField() {
    const root = this.getRootObj();

    if (root.legend_field) {
      return root.legend_field || '';
    }

    return '';
  }

  static getLegendLabel(legend) {
    const legends = this.getLegend();

    for (let i = 0; i < legends.length; i++) {
      if (legends[i].value.toLowerCase() === legend.toLowerCase()) {
        return legends[i].label;
      }
    }
    return '';
  }

  static getRootObj() {
    if (typeof window.drupalSettings !== 'undefined') {
      if (typeof window.drupalSettings.fellow_map_google_map !== 'undefined') {
        return window.drupalSettings.fellow_map_google_map;
      }
    }

    return null;
  }
}

export default DrupalHelper;
